import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { trim } from 'lodash';
import {
  Tooltip, OverlayTrigger,
} from 'react-bootstrap';
import { fetchAccountResults } from '../../../Dashboard/DashboardActions';
import { getAccountResults } from '../../../Dashboard/DashboardReducer';
import { getUser } from '../../../Auth/AuthReducer';

import styles from '../opportunity-box/styles.css';

class ImportantTab extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.mounted = true;
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { isActive } = nextProps;
    if (isActive && this.props.isActive !== isActive) {
      this.checkProps(nextProps);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  checkProps(props) {
    const {
      account, isLoading, isLoaded, isActive,
    } = props;
    const id = account.account_id;
    if (isActive && this.mounted && !isLoading && !isLoaded) {
      this.props.dispatch(fetchAccountResults(id)).then(() => {
        if (this.mounted) {
          this.refreshTable();
        }
      });
    } else {
      this.refreshTable();
    }
  }
  refreshTable() {
    if (this.props.measure) {
      this.props.measure();
    }
  }


  render() {
    const {
      isLoaded, isLoading, results, account,
    } = this.props;
    const loading = !isLoaded || isLoading;
    if (loading || results.length === 0) {
      return null;
    }
    const total = results.length;

    const resultTags = results.map((result, i) => {
      let suffix = null;
      let prefix = null;
      if (i < total - 2) {
        suffix = (<span>, </span>);
      } else if (total > 1 && i === total - 1) {
        prefix = (<span className={styles.ampersand}> &amp; </span>);
      }
      let r = (<span>{result.result}</span>);

      const hasTip = result.definition && trim(result.definition).length > 0;

      if (hasTip) {
        const tip = (
          <Tooltip id={`${account.account_id}-${result.id}`}>{result.definition}</Tooltip>
        );
        r = (<OverlayTrigger placement="right" overlay={tip}>{r}</OverlayTrigger>);
      }
      return (
        <span key={result.id}>{prefix} {r} {suffix}</span>
      );
    });


    return (
      <div className={`${styles.section} text-left`}>
        <div className={`${styles.topLine} ${styles.paddingV}`}>
          <div><strong>Important Results:</strong></div>
          <div>{resultTags}</div>
        </div>
      </div>
    );
  }
}

ImportantTab.propTypes = {
  account: PropTypes.shape({
    account_id: PropTypes.string,
  }).isRequired,
  results: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    result: PropTypes.string,
    definition: PropTypes.string,
  })).isRequired,
  dispatch: PropTypes.func.isRequired,
  measure: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
};

ImportantTab.defaultProps = {
  measure: () => {},
};

function mapStateToProps(state, ownProps) {
  const id = ownProps.account.account_id;
  const accountResults = getAccountResults(state, id) || {};
  const isLoading = accountResults.status === 'loading';
  const isLoaded = accountResults.status === 'loaded';
  const results = !isLoading && isLoaded ? accountResults.results.important_results || [] : [];
  return {
    results,
    isLoading,
    isLoaded,
    auth: getUser(state),
  };
}

export default connect(mapStateToProps)(ImportantTab);
